module.exports = __webpack_public_path__ + "static/media/carif.ed3350bd.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/carif/images/carif.mp4
// module id = 557
// module chunks = 0